import { Link } from "react-router-dom";
import { categoryQuickLinks, regionOptions, yearOptions } from "@/mocks/movies";

export default function CategoryQuickLinks() {
  return (
    <section className="px-4 md:px-10 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {categoryQuickLinks.map((item) => (
            <Link
              key={item.key}
              to={`/category?type=${encodeURIComponent(item.key)}`}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 border border-background-200/60 rounded-lg hover:border-accent-500/60 transition-colors"
            >
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-300 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <span className="min-w-0">
                <span className="block text-sm md:text-base font-semibold text-foreground-50 group-hover:text-accent-500 transition-colors">
                  {item.label}
                </span>
                <span className="block text-xs text-foreground-500 mt-1 truncate">{item.desc}</span>
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-5 bg-background-100 border border-background-200/60 rounded-lg">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-map-pin-line text-secondary-500" />
              <span className="text-sm font-semibold text-foreground-100">按地区浏览</span>
            </div>
            <div className="flex flex-wrap gap-2">
              {regionOptions.slice(1).map((region) => (
                <Link
                  key={region}
                  to={`/category?region=${encodeURIComponent(region)}`}
                  className="px-3 py-1.5 rounded-full bg-secondary-100/70 text-secondary-900 text-xs md:text-sm hover:bg-secondary-500 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {region}
                </Link>
              ))}
            </div>
          </div>

          <div className="p-5 bg-background-100 border border-background-200/60 rounded-lg">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-calendar-line text-accent-500" />
              <span className="text-sm font-semibold text-foreground-100">按年份浏览</span>
            </div>
            <div className="flex flex-wrap gap-2">
              {yearOptions.slice(1).map((year) => (
                <Link
                  key={year}
                  to={`/category?year=${year}`}
                  className="px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-900 text-xs md:text-sm hover:bg-accent-500 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {year} 年
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}